module.exports = __webpack_public_path__ + "img/profil.011ba77a.svg";